import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {LinearProgress} from '@mui/material';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  
  const [keyword, setKeyword] = React.useState("");
  const [filter, setFilter] = React.useState(false);
  const [pageLoading, setPageLoading] = React.useState(false);
  const [selectedOneIndex, setSelectedOneIndex] = React.useState(-1);
  const [selectedTwoIndex, setSelectedTwoIndex] = React.useState(-1);
  const [keywordsOneList, setKeywordsOneList] = React.useState([]);
  const [keywordsTwoList, setKeywordsTwoList] = React.useState([]);
  const [keywordOneListObj, setKeywordOneListObj] = React.useState({});
  const [keywordTwoListObj, setKeywordTwoListObj] = React.useState({});


  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  const handleOneListItemClick = (event, index, obj) => {
    setSelectedOneIndex(index);
    setKeywordOneListObj(obj);
  };
  const handleTwoListItemClick = (event, index, obj) => {
    setSelectedTwoIndex(index);
    setKeywordTwoListObj(obj);
  };

  React.useEffect(() => {	
    if(open && props.dataObj && props.dataObj.autoId){
      getApiKeywords();
    }
	}, [open,props.dataObj,filter]);

  async function getApiKeywords(){ 
    let apiUrl=API_URL+'/crm-keywords?sorting=keywordName&maxRows=50&keyword='+keyword;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'uid': userObj.loginId,
        'fullName': userObj.fullName,
        'token': userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    setPageLoading(true);
    await axios(config)
       .then(response => {
      setPageLoading(false);
      //document.write(JSON.stringify(response.data));
      if(response && response.data && response.data.responseTxt==="success"){  
        setKeywordsOneList(response.data.obj);
      }
    })
  }

  React.useEffect(() => {	
    setKeywordsTwoList([]);
    if(open && userObj && userObj.loginId && userObj.loginId.length>0 && props.dataObj && props.dataObj.autoId>0){
      getApiSelectedKeywords();
    }
	}, [open,userObj,props.dataObj]);

  async function getApiSelectedKeywords(){ 
    let apiUrl=API_URL+'/selected-keywords-product-free?id='+props.dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'uid': userObj.loginId,
        'fullName': userObj.fullName,
        'token': userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    setPageLoading(true);
    await axios(config)
       .then(response => {
      setPageLoading(false);
      //document.write(JSON.stringify(response.data));
      if(response && response.data && response.data.responseTxt==="success"){  
        setKeywordsTwoList(response.data.obj);	
        if(response.data.obj && response.data.obj.length>0){
          filterMyList();
        }
      }
    })
  }

  function filterMyList(){
    if(keywordsOneList && keywordsOneList.length>0 && keywordsTwoList && keywordsTwoList.length>0){
    const result = keywordsOneList.filter(md => 
      keywordsTwoList.every(fd => fd.autoId !== md.autoId));
      setKeywordsOneList(result);
    }  
  }

	function saveData(opt){
    
		if(opt && userObj && userObj.loginId>0){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('actionFlag', opt);
      if(opt===1 && keywordOneListObj && keywordOneListObj.autoId>0){
        data.append('keywordId', keywordOneListObj.autoId);
        data.append('keywordName', keywordOneListObj.keywordName);

      }else if(opt===2 && keywordTwoListObj && keywordTwoListObj.autoId>0){
        data.append('keywordId', keywordTwoListObj.autoId);
        data.append('keywordName', keywordTwoListObj.keywordName);

      }
      
      let apiURL='/update-keywords-product-free';
      let myMessage="It has been saved.";
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {        
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){ 
          setSelectedOneIndex(-1);
          setSelectedTwoIndex(-1);         
          setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage(myMessage);
          getApiSelectedKeywords();
          ///window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("This was added earlier. Kindly select another keyword name.");
            return false;  					

        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  
  // Handles the 'Enter' key press event
	function onEnter(event) {
		// Check if the pressed key is 'Enter'
		if (event.key === 'Enter') {
			// If 'Enter' is pressed, trigger the login function
			setFilter(!filter);
		}
	}


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj.productTitle}</h3></div>
                  <Box mt={2}>
                  {pageLoading?<LinearProgress />:null}
                    <Grid container spacing={2}>
                      <Grid item md={6} xs={12} className='topicBox' >                        
                          <b>Keywords</b>
                          <TextField 
                            onKeyPress={(event)=>{onEnter(event)}}
                            onChange={event => setKeyword(event.target.value)} 
                            value={keyword} placeholder={'Search'} fullWidth size="small" variant="outlined" />
                          <List component="nav" style={{maxHeight: '50vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
                            {(keywordsOneList || []).map((row,i)=>(
                              <ListItemButton
                                selected={selectedOneIndex === i}
                                onClick={(event) => handleOneListItemClick(event, i, row)}
                                key={'t'+i}
                              >
                                  {selectedOneIndex === i?
                                    <ListItemIcon>
                                      <CheckIcon />
                                    </ListItemIcon>
                                  :null}  
                                  <ListItemText primary={row.keywordName} />
                              </ListItemButton>
                            ))}                      
                          </List>                  
                          {selectedOneIndex>-1?  
					    	            <Button onClick={() => {saveData(1)}} size="small" variant="outlined" >Select</Button>
                          :null}  
                      </Grid>
                      <Grid item md={6} xs={12} >
                          <b>Selected Keywords</b>
                          <hr/>
                          <List component="nav" style={{maxHeight: '50vh', overflow: 'auto'}} aria-label="secondary mailbox folder">
                            {(keywordsTwoList || []).map((row,i)=>(
                              <ListItemButton
                                selected={selectedTwoIndex === i}
                                onClick={(event) => handleTwoListItemClick(event, i, row)}
                                key={'t'+i}
                              >                                  
                                  {selectedTwoIndex === i?
                                    <ListItemIcon>
                                      <CheckIcon />
                                    </ListItemIcon>
                                  :null}
                                  <ListItemText primary={row.keywordName} />
                              </ListItemButton>
                            ))}                      
                          </List>              
                          {selectedTwoIndex>-1?      
					    	            <Button onClick={() => {saveData(2)}} size="small" variant="outlined" >Delete</Button>
                          :null}  
                      </Grid>
                    </Grid>
                  </Box>
                 
                      
                      {/* <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
								      </Box> */}

            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;